import type { SignalPriority } from '@parcel/types';

export function priorityLabel(priority: SignalPriority): string {
  if (priority === 'high') return 'High';
  if (priority === 'medium') return 'Medium';
  return 'Low';
}

/** Shared priority dot colors: high → green, medium → blue, low → slate. */
export const PRIORITY_DOT_CLASS: Record<SignalPriority, string> = {
  high: 'bg-green-500',
  medium: 'bg-blue-500',
  low: 'bg-slate-400',
};
